import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { createCouponVariables, CouponAppliedTo, CouponType } from '@api/graphql/types';
import CouponForm from '../components/CouponForm';
import DateUtils from '@root/utils/DateUtils';
import { ProductIdName } from '@modules/PromotionCategory/components/ProductInput';
import { removeProp } from '@root/utils/Object';
import { CodeCodeUsageCount } from "../components/CouponCodesField";

type Props = {
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: createCouponVariables;
    originalMaxUsageCount: number;
}

class CouponCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            formData: {
                name: '',
                active_from: DateUtils.formatDateTime(new Date()),
                active_to: DateUtils.formatDateTime(new Date()),
                type: CouponType.PERCENT,
                applied_to: CouponAppliedTo.PRODUCT,
                is_free_shipping: false,
                price_ranges: [],
                is_active: true,
                shipping_method_id: null,
                payment_method_id: null,
                usage_count: 1,
                is_combinable: true,
                coupon_code_attributes: {
                    count: 0,
                    length: 0,
                    type: null,
                    prefix: '',
                    suffix: '',
                },
                codes: [],
                products: null,
            },
            originalMaxUsageCount: 1,
        };
    }

    public onSubmit = (formData: createCouponVariables, codes: CodeCodeUsageCount[], products: ProductIdName[]) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createCoupon,
            variables: this.cleanFormDataForSubmit(formData, codes, products),
        });
    }

    private cleanFormDataForSubmit = (formData: createCouponVariables, codes: CodeCodeUsageCount[], products: ProductIdName[]): createCouponVariables => {
        const newFormData: createCouponVariables = { ...formData };

        // Removing '__typename'
        removeProp(newFormData, '__typename');

        // We have to get the coupon codes from the { code, usage_count } type
        newFormData.codes = codes.map((code: CodeCodeUsageCount) => code.code);

        // We have to get the product ids from the { id, name } type
        newFormData.products = products.map((product: ProductIdName) => product.id);

        return newFormData;
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.coupon.couponCreate'})}</h5>
                        </div>
                        <div className="ibox-content">
                            <CouponForm formData={this.state.formData} onSubmit={this.onSubmit} originalMaxUsageCount={this.state.originalMaxUsageCount} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(CouponCreate);



// WEBPACK FOOTER //
// ./src/modules/Coupon/pages/CouponCreate.tsx